









































import {Component, Prop, Vue} from 'vue-property-decorator';
import MeterModelForm from '@/data/models/meter-model-form';
import DateUtils from '@/helpers/date-utils';
import Button from '@/components/commons/Button.vue';
import dayjs from "dayjs";
import {saveAsJsonLocally} from "@/helpers/utils";

@Component({
  components: {Button},
})
export default class CreateMeterIdentifications extends Vue {
  @Prop({required: true})
  opened: boolean;

  @Prop({required: false, default: false, type: Boolean})
  multiple: boolean;

  @Prop({required: true})
  meterModelForm: MeterModelForm;

  startDate: string = dayjs().toISOString();
  endDate: string = dayjs().toISOString();

  startDateMenu: boolean = false;
  endDateMenu: boolean = false;

  get dialog(): boolean {
    return this.opened;
  }

  set dialog(value: boolean) {
    this.$emit('close', value);
  }

  get startDateFormat(): string {
    return DateUtils.toDDMMYYYY(this.meterModelForm.startDate);
  }

  get endDateFormat(): string {
    return DateUtils.toDDMMYYYY(this.meterModelForm.endDate);
  }

  setStartDate(date: string): void {
    this.startDateMenu = false;
    this.meterModelForm.startDate = DateUtils.isoStringToDate(date);
  }

  setEndDate(date: string): void {
    this.endDateMenu = false;
    this.meterModelForm.endDate = DateUtils.isoStringToDate(date);
  }

  triggerGeneration(): void {
    if (this.multiple) {
      this.generateMultiple()
    } else {
      this.generate()
    }
  }

  triggerUpdate(): void {
    this.update()
  }

  async triggerFile(type: "model" | "update"): Promise<void> {
    this.$store.commit("showLoader", true);

    let output = {};
    if (type === "model") {
      output = await this.$dao.meters.getRequestComputeIdentificationJSON(this.meterModelForm.toJSON());
    } else {
      output = await this.$dao.meters.getModelUpdateJSON(this.meterModelForm.toJSON());
    }

    saveAsJsonLocally(output,  `${type}-${this.meterModelForm.buildingId}-${this.meterModelForm.meterId}-${this.meterModelForm.startDate}-${this.meterModelForm.endDate}.json`)

    this.$store.commit("showLoader", false);
  }

  generate(): void {
    this.$store.commit("showLoader", true);
    this.$dao.meters.requestComputeIdentification(this.meterModelForm.toJSON()).finally(() => {
      this.$store.commit("showLoader", false);
      this.dialog = false;
      this.$dialog.message.info(this.$t('detailMeter.generationDone').toString(), {timeout: 4000, position: 'bottom-center'});
    });
  }
  
  update(): void {
    this.$store.commit("showLoader", true);
    this.$dao.meters.triggerComputationUpdateForMeter(this.meterModelForm.toJSON()).finally(() => {
      this.$store.commit("showLoader", false);
      this.dialog = false;
      this.$dialog.message.info(this.$t('detailMeter.updateDone').toString(), {timeout: 4000, position: 'bottom-center'});
    });
  }

  generateMultiple(): void {
    this.$store.commit("showLoader", true);
    this.$dao.buildings.requestComputeIdentification(this.meterModelForm.toJsonSingle()).finally(() => {
      this.$store.commit("showLoader", false);
      this.dialog = false;
      this.$dialog.message.info(this.$t('detailMeter.generationDone').toString(), {timeout: 4000, position: 'bottom-center'});
    });
  }
}
